import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import { FormHelperText, InputLabel } from '@material-ui/core';
import { InputText, SelectBox, SecondaryCheckbox, DatePicker, SimpleField, YesButton, NoButton, SingleSelect } from '../../../../../Core/Controls';
import { VehicleProvider as StateProvider, VehicleScreenContext } from '../VehicleProvider';

import '../../controllerStyle.scss';

const OtherVehicleDetails = (props) => {
    // const { otherFields, otherFieldsChange } = props;
    const {
        state,
        handleSubmit,
        inputChange,
        otherFields,
        otherFieldsChange,
        jobFields,
        jobFieldsChange,
        handleCheckbox,
        dateFieldsChange,
        dateFields,
        handleTabPress,
        handleClick,
        handleActive,
        singleSelectChange,
        tempOptions
    } = useContext(VehicleScreenContext);

    console.log(tempOptions, 'tempOptions');

    return (
        <>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <SimpleField
                    inputLabel="Asset Number"
                    placeholder="Asset Number"
                    value={otherFields.assetNumber}
                    onChange={otherFieldsChange}
                    name="assetNumber"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <SimpleField
                    inputLabel="Fleet Number"
                    placeholder="Fleet Number"
                    value={otherFields.fleetNumber}
                    onChange={otherFieldsChange}
                    name="fleetNumber"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <SimpleField
                    inputLabel="Ministry Number"
                    placeholder="Ministry Number"
                    value={otherFields.ministryNumber}
                    onChange={otherFieldsChange}
                    name="ministryNumber"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <SimpleField inputLabel="Colour" placeholder="Colour" value={otherFields.colour} onChange={otherFieldsChange} name="colour" />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <SimpleField
                    inputLabel="P11D Value"
                    type="number"
                    placeholder="P11D Value"
                    value={otherFields.P11DValue}
                    onChange={otherFieldsChange}
                    name="P11DValue"
                />
                <FormHelperText error>{otherFields.errors.P11DValue}</FormHelperText>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
                <SimpleField
                    inputLabel="Latest Mileage"
                    type="number"
                    placeholder="Latest Mileage"
                    value={jobFields.vehicleLatestMileage}
                    onChange={jobFieldsChange}
                    name="vehicleLatestMileage"
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
                <InputLabel shrink>Odometer Unit Code</InputLabel>
                {/* <SelectBox value={jobFields.odometerUnitCode} onChange={jobFieldsChange} name="odometerUnitCode" List={jobFields.odometerUnitCodeList} /> */}
                <SingleSelect
                    options={jobFields.odometerUnitCodeList}
                    value={tempOptions.odometerUnitCodeValue}
                    onChange={singleSelectChange('odometerUnitCodeValue')}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <SimpleField
                    inputLabel="Description"
                    placeholder="Description"
                    value={otherFields.description}
                    onChange={otherFieldsChange}
                    name="description"
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3}>
                <InputLabel shrink>Service</InputLabel>
                {/* <SelectBox value={jobFields.odometerUnitCode} onChange={jobFieldsChange} name="odometerUnitCode" List={jobFields.odometerUnitCodeList} /> */}
                <SingleSelect
                    options={jobFields.scheduleEvents}
                    value={tempOptions.vehicleServiceScheduleIDValue}
                    onChange={singleSelectChange('vehicleServiceScheduleIDValue')}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <InputLabel shrink>DOT Schedule</InputLabel>
                {/* <SelectBox value={jobFields.odometerUnitCode} onChange={jobFieldsChange} name="odometerUnitCode" List={jobFields.odometerUnitCodeList} /> */}
                <SingleSelect
                    options={jobFields.scheduleInspection}
                    value={tempOptions.vehicleDOTScheduleIDValue}
                    onChange={singleSelectChange('vehicleDOTScheduleIDValue')}
                />
            </Grid>

            {/* <Grid item xs={6} sm={3}>
                <SecondaryCheckbox checked={jobFields.vehicleOffRoad} name="vehicleOffRoad" onChange={handleCheckbox} label="Vehicle Off Road?" />
            </Grid> */}
            {/* <Grid xs={12} container style={{ marginTop: 16, marginBottom: 16, marginLeft: 10 }}>
                <Grid xs={12} container spacing={1}>
                    <Grid item xs={12} sm={12}>
                        Vehicle Off Road?
                    </Grid>
                    <Grid item xs={1}>
                        <YesButton state={jobFields.vehicleOffRoad} name="vehicleOffRoad" onClick={() => handleClick('vehicleOffRoad', true)} />
                    </Grid>
                    <Grid item xs={1}>
                        <NoButton state={jobFields.vehicleOffRoad} name="vehicleOffRoad" onClick={() => handleClick('vehicleOffRoad', false)} />
                    </Grid>
                </Grid>
            </Grid> */}
        </>
    );
};

export default OtherVehicleDetails;
